module.exports = __webpack_public_path__ + "static/media/proj6_img2.b1176850.jpg";